<template>
  <div class="container">
    <custom-select
      label="Tipo de documento"
      name="tipoDocumento"
      :value="value"
      @input="onChange"
      @click="$emit('click')"
      :items="tiposDocumento"
    />
  </div>
</template>

<script>
import { tiposDocumento } from "@/config/constants";
import CustomSelect from "@/components/core/custom/CustomSelect";
export default {
  name: "DocumentType",
  components: { CustomSelect },
  props: {
    value: String
  },
  computed: {
    tiposDocumento() {
      return tiposDocumento;
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style scoped></style>
